<template>

  <div style=" display: flex;
    flex-direction: column; justify-content: center;">

    <div class="title" style="height: 150px; display: flex;
    justify-content: center;   color: #FFD700;;">
      <H2>砍树游戏挂号管家</H2>
    </div>

    <div style=" display: flex;
    justify-content: center;     height: 100px;">
      <div><el-button style="width: 200px; height: 50px;" type="primary" @click="add">添加账号</el-button></div>
    </div>

    <div style=" display: flex;
    justify-content: center;">
      <div><el-button style="width: 200px; height: 50px;" type="primary" @click="admin">账号管理</el-button></div>
    </div>

    <!-- <div style=" display: flex;
    justify-content: center;"  class="qr-code-container">
      <img src="../assets/0.gif" alt="QR Code" />
    </div> -->

  </div>

  

</template>

<script>
import axios from 'axios'
// import jsonFile from '@/assets/json/account.json';
// import qufu from '@/assets/json/qufu.json';

export default {
  name: "diy",
  data() {
    return {
      
    }
  },
  
  beforeCreate() {
    document.querySelector('body').classList.add("overall");
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove("overall");
  },

  mounted() {

    
  },

  methods: {
  


    add() {
      this.$router.push("/zh");
    },

    admin() {
      this.$confirm('该网站已经废弃，请前往最新的挂号管理网站：http://xundao.icu', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '我已知晓',
              center: true,
              centered:true,
              type: 'warning'
            }).then(() => {
            }).catch(() => {
            });
      // this.$router.push("/gj");
    },

    
  }
}
</script>

<style>
/* 响应式样式 */
@media screen and (max-width: 768px) {
  .el-input, .el-button {
    width: 100%;
  }
}

.qr-code-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  margin-top: 88px;
}

.qr-code-container img {
  max-width: 100%; /* 确保图片宽度不超过容器宽度 */
  max-height: 100%; /* 确保图片高度不超过容器高度 */
  width: 50%; /* 自动调整宽度 */
  height: 50%; /* 自动调整高度 */
}

.overall {
  position: absolute;
  content: ' ';
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  background-image: url("../assets/image.png");
  background-size: cover;
}

</style>